
import { defineComponent } from 'vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import CustomDialog from '~/components/Dialogs/CustomDialog.vue';
import GenericError from '@/components/common/Alerts/GenericError.vue';
import { setAutopay } from '@/api/loan';

export default defineComponent({
  name: 'ConfirmAutopayDialog',

  components: {
    CustomButton,
    CustomDialog,
    GenericError
  },

  props: {
    lastFour: { type: String, required: true },
    type: { type: String, required: true },
    paymentProviderOptionId: { type: [String, Number], required: true },
    paymentProviderDetails: { type: [String, Number], required: true },
  },

  data() {
    return {
      loading: false,
      showError: false,
    };
  },

  computed: {
    dueDate(): string {
      return this.$store.getters['Loan/getDueDate'];
    },
  },

  methods: {
    async submitPayment() {
      this.loading = true;
      try {
        await setAutopay({
          recurring_payments: true,
          payment_provider_details: this.paymentProviderDetails,
          payment_provider_option_id: this.paymentProviderOptionId,
          payment_provider_option_type: this.type
        });

        await this.$store.dispatch('Loan/getAutopayInfo');

        this.$emit('close');
      } catch {
        this.showError = true;
      } finally {
        this.loading = false;
      }
    }
  }
});

// @Prop({ type: String, required: true }) type!: 'bank' | 'card';
